import { LoaderLayout, MobileLoaderLayout } from 'modules/Layout';
import App from 'modules/App';
export const getLoader = (store)=>{
    const state = store.getState();
    const isMobileDisplayMode = App.selectors.isMobileDisplayMode(state);
    return isMobileDisplayMode ? MobileLoaderLayout : LoaderLayout;
};
